import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

//TODO: Mergear componentes en webcore
import GenericModal from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModal';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup';

import { GenericErrorScreen, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

import Title from './Title';
import Header from './Header';
import Table from './Table';

class EditarPermisos extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        window.onbeforeunload = function (event) {
            if (sessionStorage.getItem('PantallaCambios') == "true") {
                return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
        }

        this.props.getScreenData(this.props.currentScope);
        $('[data-toggle="tooltip"]').tooltip();
    }



    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.data.messageHidden) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        const { data } = this.props;

        if (data.redirect == true)
            return <Redirect to={ProcessManager.GetNextStep("EditarPermisos", "ROUTE_TO_PERFYPERM")} />

        let spinner = null;

        if (data.isFetching == true) {
            spinner = <div className="loading" />
        }

        if (data.functions.length > 0) {
            if (data.functions.Consulta == true) {
                return (
                    <div className="container-fluid concierge">
                        {spinner}

                        {/*POP UP*/}
                        <MessagePopup isHidden={data.messageHidden}
                            message={data.message}
                            classMessage={data.messageClass} />


                        

                        <Title titulo="Editar permisos" />
                        <Header historial={data.historial}
                            deleteHistorial={this.props.deleteHistorial}
                            selectHistorial={this.props.selectHistorial}
                            saveChanges={this.props.saveChanges}
                            errorSave={this.props.errorSave} />
                        <Table productos={data.productos}
                            categorias={data.categorias}
                            programas={data.programas}
                            perfiles={data.perfiles}
                            filter={data.filter}
                            funciones_tabla={data.funciones_tabla}
                            selectProducto={this.props.selectProducto}
                            selectCategoria={this.props.selectCategoria}
                            selectPrograma={this.props.selectPrograma}
                            deleteFuncion={this.props.deleteFuncion}
                            addFuncion={this.props.addFuncion} />

                        {/*MODAL*/}
                        
                        
                       
                        <GenericModal type="ALL_CUSTOM"
                            className="modal fade-out"
                            id="discardChangesModal"
                            screenSize="modal-dialog modal-generic"
                            header={
                                <h2 className="modal-title">Descartar cambios</h2>}
                            footer={
                                <div className="row">
                                    <div className="col-xs-4">
                                        <button className="btn btn-primary btn-cta" onClick={() => this.props.setRedirectOk()}>Descartar Cambios</button>
                                    </div>
                                    <div className="col-xs-8">
                                        <GenericSimpleButton text="Cancelar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />
                                    </div>
                                </div>}
                            body={<p>Usted tiene cambios sin guardar ¿Quiere descartarlos y volver a la pantalla de perfiles y permisos?</p>} />
                            
                    </div>);
            }
            else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                return (<div>
                    {spinner}
                    <GenericErrorScreen data={values} />
                </div>);

            }
        }
        else {
            return spinner;
        }
    }
}

export default EditarPermisos;